import React, { useEffect, useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl,
  FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField,
} from '@mui/material';

const emptyDesignation = {
  code: '', name: '', department: '', level: 1, is_active: true,
};

const DesignationDialog = ({ open, item, departments, loading, onClose, onSave }) => {
  const [form, setForm] = useState(emptyDesignation);

  useEffect(() => {
    setForm(item ? {
      code: item.code || '', name: item.name || '', department: item.department || '',
      level: item.level || 1, is_active: item.is_active !== false,
    } : emptyDesignation);
  }, [item, open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{item ? 'Edit Designation' : 'Add Designation'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth label="Code" value={form.code}
              onChange={(event) => setForm({ ...form, code: event.target.value })} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField fullWidth label="Name" value={form.name}
              onChange={(event) => setForm({ ...form, name: event.target.value })} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <FormControl fullWidth>
              <InputLabel id="designation-department-label">Department</InputLabel>
              <Select labelId="designation-department-label" id="designation-department" label="Department" value={form.department}
                onChange={(event) => setForm({ ...form, department: event.target.value })}>
                {departments.filter((value) => value.is_active).map((department) => (
                  <MenuItem key={department.id} value={department.id}>{department.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel id="designation-level-label">Level</InputLabel>
              <Select labelId="designation-level-label" id="designation-level" label="Level" value={form.level}
                onChange={(event) => setForm({ ...form, level: Number(event.target.value) })}>
                {Array.from({ length: 10 }, (_value, index) => index + 1).map((level) => (
                  <MenuItem key={level} value={level}>Level {level}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {item && <Grid item xs={12}>
            <FormControlLabel control={<Switch checked={form.is_active}
              onChange={(event) => setForm({ ...form, is_active: event.target.checked })} />}
              label="Active" />
          </Grid>}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained"
          disabled={loading || !form.code.trim() || !form.name.trim() || !form.department}
          onClick={() => onSave(form)}>{item ? 'Update' : 'Create'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DesignationDialog;
